import { Injectable } from '@angular/core';
import { Bank } from '../../../models';
import { ComponentStore, OnStoreInit, tapResponse } from '@ngrx/component-store';
import { DictionariesService } from '../../../http';
import { switchMap } from 'rxjs/operators';

export interface SellerBankDataState {
  banks?: Bank[];
}

@Injectable()
export class SellerBankDataStore extends ComponentStore<SellerBankDataState> implements OnStoreInit {
  public banks$ = this.select((state) => state.banks);

  constructor(private readonly dictionariesService: DictionariesService) {
    super({});
  }

  public ngrxOnStoreInit(): void {
    this.getBanks();
  }

  private getBanks = this.effect((trigger$) => {
    return trigger$.pipe(
      switchMap(() => this.dictionariesService.getBanks()),
      tapResponse(
        (banks) => {
          this.patchState({ banks });
        },
        (error) => {
          // TODO: handle error
          console.error(error);
        },
      ),
    );
  });
}
